<template>
	<div>
		<Logo style="background-color: #287AFF;"></Logo>
		<div id='initialize'>
			
			<el-form label-position='left' ref="form" :model="form" :rules="rules" label-width="200px" size="mini">
				<div id='wx-area' class="indentation">
					<el-form-item label="微信公众号或开放平台appid">
						<el-input v-model="form.wechat_app_id"></el-input>
					</el-form-item>
					<el-form-item label="微信商户号">
						<el-input v-model="form.wechat_mch_id"></el-input>
					</el-form-item>
					<el-form-item label="微信支付秘钥v1">
						<el-input v-model="form.wechat_api_key"></el-input>
					</el-form-item>
				</div>
				<div id='zfb-area' class="indentation">
					<el-form-item label="支付宝产品appid">
						<el-input v-model="form.alipay_app_id"></el-input>
					</el-form-item>
					<el-form-item label="支付宝支付公钥">
						<el-input v-model="form.alipay_public_key"></el-input>
					</el-form-item>
					<el-form-item label="支付宝支付私钥">
						<el-input v-model="form.alipay_private_key"></el-input>
					</el-form-item>
				</div>
				<div id='alert'>
					注意：支付宝和微信支付相关设置，必须要填写其中一个，可以两个都填写，若不填写则支付时不展示
				</div>
				<div>
					<el-form-item label="选择登录方式">
						<el-select v-model="form.login_type">
							<el-option
								v-for="item in login_type_options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="证件照制作价格" prop = 'ele_price'>
						<el-input v-model="form.ele_price"></el-input>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="证件照制作并换正装价格">
						<el-input v-model="form.clothes_price"></el-input>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="客服电话号码">
						<el-input v-model="form.service_phone"></el-input>
					</el-form-item>
				</div>
			</el-form>
			<el-button type="primary" @click='submit'>提交</el-button>
		</div>
	</div>
</template>

<script>
import Logo from '../components/Logo.vue'
import {
	createApp
} from '../api/index.js';
import {
	convertYuantoCent
} from '../utils/utils.js'
export default {
	components:{
		Logo
	},
	data() {
		return {
			login_type_options:[{
				value:1,
				label:'无需登录'
			},{
				value:2,
				label:'手机号短信验证登录'
			},{
				value:3,
				label:'手机号无需验证登录'
			}],
			rules:{
				ele_price:[
					{required:true,message:"必须输入电子照价格",trigger:"blur"}
				]
			},
			form:{
				email:localStorage.getItem("user"),
				wechat_app_id:'',
				wechat_mch_id:'',
				wechat_api_key:'',
				alipay_app_id:'',
				alipay_public_key:'',
				alipay_private_key:'',
				ele_price:"",
				clothes_price:"",
				service_phone:"",
				login_type:1,
			}
		}
	},
	methods:{
		submit:function(){
			this.$refs.form.validate((valid) => {
				if (valid) {
					var payParamscheckBol = (
						this.form.wechat_app_id&&
						this.form.wechat_app_id&&
						this.form.wechat_mch_id
					)||(
						this.form.alipay_app_id&&
						this.form.alipay_public_key&&
						this.form.alipay_private_key
					)
					if(payParamscheckBol){
						this.form.ele_price = convertYuantoCent(this.form.ele_price);
						this.form.clothes_price = convertYuantoCent(this.form.clothes_price);
						createApp(this.form).then(res=>{
							console.log(res)
							if(res.data.code==200){
								this.$router.push("/setBasicInfo");
							}
						}).catch(err=>{
							console.log(err)
						})
					}else{
						this.$message.error('支付宝和微信的支付参数，请至少完整输入一组！')
					}
				}
			})
			
		}
	}
}
</script>

<style scoped="scoped">
	#initialize{
		margin:30px 40px;
		box-shadow: 0px 4px 12px 0px rgba(66, 66, 66, 0.1);
		border-radius: 10px;
		padding:30px 80px 40px;
		font-size: 16px;
		font-weight: bold;
		color: #4C4C4C;
	}
	#alert{
		margin-left: 259px;
		color: #FF6161;
		position: relative;
		margin-bottom: 40px;
	}
	#alert::before{
		content: " ";
		background-image: url(../assets/icon_notice@2x.png);
		background-size: 14px 14px;
		background-position: 0 0;
		position: absolute;
		left: -20px;
		top: 2px;
		width: 14px;
		height: 14px;
	}
	.indentation{
		width: 80%;
		margin-left: 20%;
		position: relative;
	}
	#zfb-area::before{
		content: "支付宝支付";
		position: absolute;
		top:5px;
		left: -25%;
	}
	#wx-area::before{
		content: "微信支付";
		position: absolute;
		top:5px;
		left: -25%;
	}
</style>
